import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["activeBound", "month", "onActiveBoundChange", "onChange", "value"];
import { useState } from 'react';
import { syntheticEvent } from '../../../utils/SyntheticEvent/SyntheticEvent';
import unescapedText from 'I18n/utils/unescapedText';
import { AbstractMonth } from '../AbstractMonth';
import { equals, isDateInRange, isValidRange } from '../../../utils/SimpleDate';
import { Day } from '../Day';
// import { preventDefaultHandler } from '../../../utils/DomEvents';
import { jsx as _jsx } from "react/jsx-runtime";
export const MonthWithRange = _ref => {
  let {
      activeBound,
      month,
      onActiveBoundChange,
      onChange,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    startDate,
    endDate
  } = value;
  const [hoveredDate, setHoveredDate] = useState();
  let minMaxProps = {};
  if (activeBound === 'start' && endDate) {
    minMaxProps = {
      max: endDate,
      maxValidationMessage: unescapedText('ui.dateRange.startDateAfterEndDate')
    };
  } else if (activeBound === 'end' && startDate) {
    minMaxProps = {
      min: startDate,
      minValidationMessage: unescapedText('ui.dateRange.endDateBeforeStartDate')
    };
  }
  const onDateClick = evt => {
    const clickedDate = evt.target.value;
    let newValue;
    if (activeBound === 'start') {
      newValue = {
        startDate: clickedDate,
        endDate: value.endDate
      };
    } else {
      newValue = {
        startDate: value.startDate,
        endDate: clickedDate
      };
    }
    onChange(syntheticEvent(newValue));
    onActiveBoundChange(syntheticEvent(newValue.startDate ? 'end' : 'start'));
  };
  return /*#__PURE__*/_jsx(AbstractMonth, Object.assign({}, rest, minMaxProps, {
    month: month,
    onDateClick: onDateClick,
    onDateMouseEnter: evt => {
      setHoveredDate(evt.target.value || null);
    },
    onDateMouseLeave: evt => {
      if (equals(hoveredDate, evt.target.value)) setHoveredDate(null);
    },
    onMouseDown: e => {
      e.preventDefault();
    },
    children: (simpleDate, dayProps) => {
      const isRangeStart = equals(simpleDate, startDate);
      const isRangeEnd = equals(simpleDate, endDate);
      const isInRange = isValidRange({
        startDate,
        endDate
      }) && isDateInRange(simpleDate, startDate, endDate) && !isRangeStart && !isRangeEnd;
      const isInHoveredRange = simpleDate !== startDate && simpleDate !== endDate && (isValidRange(Object.assign({}, value, {
        startDate: hoveredDate
      })) && isDateInRange(simpleDate, hoveredDate, endDate) || isValidRange(Object.assign({}, value, {
        endDate: hoveredDate
      })) && isDateInRange(simpleDate, startDate, hoveredDate));
      return /*#__PURE__*/_jsx(Day, Object.assign({}, dayProps, {
        isRangeStart: isRangeStart,
        isRangeEnd: isRangeEnd,
        isSelected: isRangeStart || isRangeEnd,
        isInRange: isInRange || isInHoveredRange,
        children: simpleDate.date
      }));
    }
  }));
};